"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShellRoutesArray = getShellRoutesArray;
var _react = _interopRequireDefault(require("react"));
var _NuiPageContainer = _interopRequireDefault(require("../containers/NuiPageContainer"));
var _Errors = require("../components/Errors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return shell routes in a route object array
function getShellRoutesArray() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var useAnonymousErrorRoutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return [{
    element: /*#__PURE__*/_react.default.createElement(_NuiPageContainer.default, null),
    path: baseUrl,
    children: [{
      path: 'serverError',
      element: /*#__PURE__*/_react.default.createElement(_Errors.ServerError, null),
      handle: {
        status: 500,
        isAnonymous: useAnonymousErrorRoutes
      }
    }, {
      path: 'forbidden',
      element: /*#__PURE__*/_react.default.createElement(_Errors.Forbidden, null),
      handle: {
        status: 403,
        isAnonymous: useAnonymousErrorRoutes
      }
    }, {
      path: '*',
      element: /*#__PURE__*/_react.default.createElement(_Errors.NotFound, null),
      handle: {
        status: 404,
        isAnonymous: useAnonymousErrorRoutes
      }
    }]
  }];
}